module.exports = __webpack_public_path__ + "img/iost.34c0963c.svg";